import React from "react";
import { Navigate } from "react-router-dom";
import { appRoutes } from "./routes";
import CacheStorage from "../service/storage/CacheStorage";
import StorageKeys from "../const/StorageKeys";
import SessionStorage from "../service/storage/SessionStorage";
import UtilityHelper from "../service/utilities/UtilityHelper";
import LoginProvider from "../provider/onboarding/login/LoginProvider";

type ProtectedRouteType = {
  redirectTo?: string;
  allowGuest?: boolean;
  children: React.ReactNode;
};

export const MiddlewareLogin = ({
  redirectTo = appRoutes.routeNameHome,
  children,
}: ProtectedRouteType) => {
  const code: string = UtilityHelper.getUrlCompanyCode();

  if (UtilityHelper.isNumber(code!)) {
    const guestStatus: string =
      SessionStorage.getValue(StorageKeys.guest_status) || "0";
    const webConfig: string =
      CacheStorage.getValue(StorageKeys.web_app_config) || "";

    if (UtilityHelper.isEmpty(webConfig)) {
      return <Navigate to={appRoutes.routeNameSplash} replace />;
    } else {
      if (guestStatus === "0") {
        let launchStatus: string =
          CacheStorage.getValue(StorageKeys.login_status) || "0";

        let branchId: string = CacheStorage.getValue(StorageKeys.branch_id);

        branchId = branchId || "";

        if (UtilityHelper.isEmpty(branchId)) {
          launchStatus = "0";
        }

        if (launchStatus === "1") {
          return <Navigate to={redirectTo} replace />;
        }
      }
    }
  } else {
    return <Navigate to={appRoutes.routeNameBoarding} replace />;
  }

  return <>{children}</>;
};

export const MiddlewareDashboard = ({
  redirectTo = appRoutes.routeNameLogin,
  allowGuest = false,
  children,
}: ProtectedRouteType) => {
  const code: string = UtilityHelper.getUrlCompanyCode();

  if (UtilityHelper.isNumber(code!)) {
    const guestStatus: string =
      SessionStorage.getValue(StorageKeys.guest_status) || "0";

    let launchStatus: string =
      CacheStorage.getValue(StorageKeys.launch_status) || "0";

    let accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) || "0";

    if (allowGuest && guestStatus === "1") {
      accountId = "1";
    }

    let branchId: string = CacheStorage.getValue(StorageKeys.branch_id);

    branchId = branchId || "";

    if (UtilityHelper.isEmpty(branchId)) {
      launchStatus = "0";
      accountId = "0";

      LoginProvider.logout();
    }

    if (launchStatus === "0" && accountId === "0") {
      return <Navigate to={redirectTo} replace />;
    }
  } else {
    return <Navigate to={appRoutes.routeNameBoarding} replace />;
  }

  return <>{children}</>;
};
